import * as React from 'react';
import { DateField, DateFieldProps } from 'react-admin';
import { palette } from '../../../Theme';

const ShsDateString: React.FC<DateFieldProps> = ({ source, locales = 'uk-UA', record }, textColor = 'inherit') => (
    <DateField sx={{ color: textColor }} source={source as any} record={record} locales={locales} />
);
export default ShsDateString;
